export {
    default as saveMailboxJunkEmailConfiguration,
} from './actions/saveMailboxJunkEmailConfiguration';

export {
    default as getMailboxJunkEmailConfiguration,
} from './utils/getMailboxJunkEmailConfiguration';

export {
    default as getMailboxJunkEmailByScenarioId,
} from './utils/getMailboxJunkEmailByScenarioId';

export {
    default as initMailboxJunkEmailConfiguration,
} from './actions/initMailboxJunkEmailConfiguration';

export { default as SpamScenarioId } from './store/schema/SpamScenarioId';
